import http from './http'
import { AxiosPromise } from 'axios'
import {
	ICompleteAuthenticationResponse,
	IMfaAuthenticator,
	IMfaChallengeResponse,
	OobChannelType,
} from '../types/auth'

function getMfaAuthenticators(
	mfaToken: string
): AxiosPromise<IMfaAuthenticator[]> {
	return http({
		method: 'GET',
		url: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/mfa/authenticators`,
		headers: {
			authorization: `Bearer ${mfaToken}`,
		},
	})
}

function mfaChallengeReq(
	authenticatorId: string,
	mfaToken: string
): AxiosPromise<IMfaChallengeResponse> {
	return http({
		method: 'POST',
		url: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/mfa/challenge`,
		data: {
			client_id: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
			challenge_type: 'oob',
			mfa_token: mfaToken,
			authenticator_id: authenticatorId,
		},
	})
}

function completeAuthentication(
	oobCode: string,
	bindingCode: string,
	mfaToken: string
): AxiosPromise<ICompleteAuthenticationResponse> {
	return http({
		method: 'POST',
		url: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/oauth/token`,
		data: {
			grant_type: 'http://auth0.com/oauth/grant-type/mfa-oob',
			client_id: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
			mfa_token: mfaToken,
			oob_code: oobCode,
			binding_code: bindingCode,
			scope: 'openid profile email user_id create:user_tickets',
		},
	})
}

function registerAuthenticator(
	oobChannels: Array<OobChannelType>,
	phoneNumber: string,
	mfaToken: string
): AxiosPromise<IMfaAuthenticator> {
	return http({
		method: 'POST',
		url: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/mfa/associate`,
		headers: {
			authorization: `Bearer ${mfaToken}`,
			'content-type': 'application/json',
		},
		data: {
			authenticator_types: ['oob'],
			oob_channels: oobChannels,
			phone_number: phoneNumber,
		},
	})
}

function changePassword(email: string): AxiosPromise<any> {
	return http({
		method: 'POST',
		url: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`,
		data: {
			client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
			connection: 'Username-Password-Authentication',
			email: email,
		},
	})
}

function skipMfaUntil(untilDate: string, userId: string): AxiosPromise<any> {
	return http({
		method: 'POST',
		url: `/p/user/${userId}/metadata`,
		data: {
			metadata: {
				skip_mfa_until: untilDate,
			},
		},
	})
}

function acceptTermsOfService(): AxiosPromise<any> {
	return http({
		method: 'GET',
		url: `/p/approve`,
	})
}

export {
	getMfaAuthenticators,
	mfaChallengeReq,
	completeAuthentication,
	registerAuthenticator,
	changePassword,
	skipMfaUntil,
	acceptTermsOfService,
}
